import React from 'react'
import { trackAffiliateClick } from '../utils/affiliate-tracking'

/**
 * Parse markdown links in message content and render as clickable elements.
 * Tracks affiliate link clicks via the dashboard API.
 */
export function renderMessageContent(content: string, primaryColor: string, publicKey?: string): React.ReactNode {
  // Match markdown links: [label](url)
  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g
  const parts: React.ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null

  while ((match = linkRegex.exec(content)) !== null) {
    // Add text before the link
    if (match.index > lastIndex) {
      parts.push(content.slice(lastIndex, match.index))
    }

    const label = match[1]
    const url = match[2]
    const isAffiliate = /booking\.com|rentalcars\.com|getyourguide\.com|hotels\.com/i.test(url)

    parts.push(
      <a
        key={match.index}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          if (isAffiliate && publicKey) {
            trackAffiliateClick(url, label, publicKey)
          }
        }}
        style={{
          color: primaryColor,
          textDecoration: 'underline',
          fontWeight: 500,
          cursor: 'pointer',
        }}
      >
        {label}
      </a>
    )
    lastIndex = match.index + match[0].length
  }

  // Add remaining text
  if (lastIndex < content.length) {
    parts.push(content.slice(lastIndex))
  }

  return parts.length > 0 ? <>{parts}</> : content
}
